import {IconButton, IconButtonProps, makeStyles} from "@material-ui/core";
import React from "react";

const useStylesButton = makeStyles((theme) => ({ root: { padding: "5px" } }));

export const TableButton = (props: IconButtonProps) => {
  const classesButton = useStylesButton();

  return <IconButton classes={classesButton} {...props} />;
};
